import { MailboxInfo } from 'owa-client-ids';
import { getConnectedAccountHeaders } from './getConnectedAccountHeaders';
import {
    setHeaders,
    RequestOptions,
    HeadersWithoutIterator,
    getRequestOptionsOrDefault,
} from 'owa-headers-core';

export async function getConnectedAccountRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions> {
    const defaultRequestOptions = getRequestOptionsOrDefault(mailboxInfo);
    defaultRequestOptions.headers = await getHeadersForConnectedAccount(
        mailboxInfo.primarySmtpAddress
    );
    defaultRequestOptions.authNeededOnUnAuthorized = false;
    return defaultRequestOptions;
}

async function getHeadersForConnectedAccount(
    primarySmtpAddress: string
): Promise<HeadersWithoutIterator> {
    const headers = new Headers();
    const connectedAccountHeaders = await getConnectedAccountHeaders(primarySmtpAddress);
    setHeaders(headers, connectedAccountHeaders);

    return headers;
}
